var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import styles from "./DistributionLevelFactorScore.module.scss";
import { FilterContext } from "../../providers/FilterProvider";
var DistributionLevelFactorScore = function (_a) {
    var _b, _c;
    var levels = _a.levels, backgroundColors = _a.backgroundColors, leadersScoreBelowTarget = _a.leadersScoreBelowTarget, backgroundBorderColors = _a.backgroundBorderColors;
    var count = levels.filter(function (level) { return level > 0; }).length;
    var dividedWidth = 100 / count;
    var getFilters = useContext(FilterContext).getFilters;
    var isProjectSingleSelect = ((_c = (_b = getFilters()) === null || _b === void 0 ? void 0 : _b.project) === null || _c === void 0 ? void 0 : _c.length) != 1 ? true : false;
    var levelSum = levels.reduce(function (accumilator, level) { return accumilator + level; }, 0);
    return (_jsxs("div", { children: [_jsx("div", __assign({ "data-testid": "distributionLevelFactorScore", className: styles.distributionLevelFactorScoreContainer }, { children: levels.map(function (level, index) {
                    if (level <= 0) {
                        return null;
                    }
                    var style = {
                        width: "".concat(dividedWidth * level, "%"),
                        borderRadius: "4px",
                        height: "24px",
                        textAlign: "center",
                        backgroundColor: backgroundColors[index],
                        color: (backgroundBorderColors === null || backgroundBorderColors === void 0 ? void 0 : backgroundBorderColors[index])
                            ? undefined
                            : index >= 3
                                ? "var(--background-color)"
                                : undefined,
                        border: (backgroundBorderColors === null || backgroundBorderColors === void 0 ? void 0 : backgroundBorderColors[index])
                            ? "1px solid ".concat(backgroundBorderColors[index])
                            : index < 2
                                ? "1px solid var(--metric-lvl-3)"
                                : undefined,
                        fontSize: "12px",
                        lineHeight: "24px",
                        fontFamily: "var(--font-stack-full-regular)",
                    };
                    return !levelSum ? (_jsx(_Fragment, {})) : (_jsx("div", __assign({ style: style }, { children: Math.round((level / levelSum) * 100) }), index));
                }) })), !isProjectSingleSelect && (_jsxs("div", __assign({ className: styles.distributionBelowText }, { children: [Math.round(leadersScoreBelowTarget), "% of leaders scored below target."] })))] }));
};
export default DistributionLevelFactorScore;
